const assetTransformer = require('./asset');
const blockTransformer = require('./block');
const isResolvedResource = require('../contentful/is-resolved-resource');
const isResolvedCollection = require('../contentful/is-resolved-collection');

const createEntryLink = (entry) => {
  return {
    sys: {
      type: 'Link',
      linkType: 'Entry',
      id: entry.id
    }
  };
};


module.exports = {
  contentfulToInternal(entry) {
    const result = {
      id: entry.sys.id,
      published: Boolean(entry.sys.publishedVersion),
      updated: entry.sys.publishedVersion && entry.sys.version > entry.sys.publishedVersion + 1,
      draft: !entry.sys.publishedVersion,
      archived: Boolean(entry.sys.archivedVersion),

      name: entry.fields.name['nb-NO'],
      slug: entry.fields.slug['nb-NO'],
      description: false,
      logo: null,
      logoStandalone: null,
      logoAdmin: null,
      frontpageContent: [],
      isInternal: true,
      contentType: null,
      webpageUrl: entry.fields.webpageUrl['nb-NO']
    };

    const description = entry.fields.description;
    if (description) {
      result.description = description['nb-NO'];
    }

    // brands type: internal/external
    if (entry.fields.type && entry.fields.type['nb-NO'] && entry.fields.type['nb-NO'] === 'external') {
      result.isInternal = false;
    }

    if (entry.fields.frontpageContent && entry.fields.frontpageContent['nb-NO'] && isResolvedCollection(entry.fields.frontpageContent['nb-NO'])) {
      result.frontpageContent = entry.fields.frontpageContent['nb-NO'].map(blockTransformer.contentfulToInternal);
    }

    if (entry.sys && entry.sys.contentType) {
      result.contentType = entry.sys.contentType.sys.id;
    }

    if (entry.fields.logo && entry.fields.logo['nb-NO'] && isResolvedResource(entry.fields.logo['nb-NO'])) {
      result.logo = assetTransformer.contentfulToInternal(entry.fields.logo['nb-NO']);
    }

    if (entry.fields.logoStandalone && entry.fields.logoStandalone['nb-NO'] && isResolvedResource(entry.fields.logoStandalone['nb-NO'])) {
      result.logoStandalone = assetTransformer.contentfulToInternal(entry.fields.logoStandalone['nb-NO']);
    }

    if (entry.fields.logoAdmin && entry.fields.logoAdmin['nb-NO'] && isResolvedResource(entry.fields.logoAdmin['nb-NO'])) {
      result.logoAdmin = assetTransformer.contentfulToInternal(entry.fields.logoAdmin['nb-NO']);
    }

    // Update model status based on content blocks status
    result.frontpageContent.forEach((rd) => {
      if (!rd.published || rd.updated) {
        result.updated = true;
      }
    });

    return result;
  },

  internalToContentful(make) {
    const result = {
      fields: {
        frontpageContent: {
          'nb-NO': null
        }
      }
    };

    if (make.frontpageContent) {
      result.fields.frontpageContent = {
        'nb-NO': make.frontpageContent.map(createEntryLink)
      };
    }

    if (make.webpageUrl) {
      result.fields.webpageUrl = {
        'nb-NO': make.webpageUrl
      };
    }

    return result;
  }

};
